import { useMemo } from 'react';
import { OPERATIONS } from '~graphql-types';
import { useViewer } from './use-viewer';

const findPermission = (permissions, ...slugs) => {
  let result;
  let temp = permissions;
  for (let i = 0; i < slugs.length; i++) {
    if (!temp) {
      result = null;
      break;
    }
    const permission = temp.find((item) => item.slug === slugs[i]);
    temp = permission?.childPermissions;
    result = permission;
  }
  return result;
};

export const useOperations = (...slugs) => {
  const viewer = useViewer();
  const operations = useMemo(
    () => findPermission(viewer.currentRole.role.permissions, ...slugs)?.operations,
    [slugs, viewer.currentRole.role.permissions]
  );

  return useMemo(() => {
    let canCreate = false;
    let canDelete = false;
    let canRead = false;
    let canUpdate = false;

    operations?.forEach((item) => {
      if (item === OPERATIONS.CREATE) canCreate = true;
      if (item === OPERATIONS.DELETE) canDelete = true;
      if (item === OPERATIONS.READ) canRead = true;
      if (item === OPERATIONS.UPDATE) canUpdate = true;
    });

    return { canCreate, canDelete, canRead, canUpdate };
  }, [operations]);
};
